<style scoped>
div.app-input-text > div {
  display: inline-block;
}
.mini {
  max-width: 55px;
}
.mini-short {
  max-width: 75px;
}
.short {
  max-width: 110px;
}
.medium {
  max-width: 165px;
}
.long {
  max-width: 300px;
}
.full {
  max-width: 1200px;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppInputComponent extends AppComponent {
  @Prop({ required: true })
  value;

  @Prop({ required: false })
  placeholder;

  @Prop({ required: false, default: null })
  options;

  @Prop({ required: false, default: false })
  disabled;

  @Prop({ required: false, default: false })
  readonly;

  /**
   * デフォルトサイズ
   */
  get defaultSize () {
    return 'medium';
  }

  /**
   * v-model対応
   */
  get model () {
    return this.value;
  }

  /**
   * v-model対応
   */
  set model (value) {
    this.$emit('input', value);
  }

  // デフォルトでクリア可能
  get clearable () {
    return (this.options && 'clearable' in this.options) ? this.options.clearable : true;
  }

  // プリフィクス
  get optionPrefix () {
    return (this.options && 'prefix' in this.options) ? this.options.prefix : '';
  }

  // サフィックス
  get optionSuffix () {
    return (this.options && 'suffix' in this.options) ? this.options.suffix : '';
  }

  // クラス
  get optionClass () {
    let optionClass = (this.options && 'class' in this.options) ? this.options.class : [this.defaultSize];
    if (this.computedReadonly) {
      if (!Array.isArray(optionClass)) {
        optionClass = [optionClass];
      }
      optionClass.push('is-readonly');
    }
    return optionClass;
  }

  /**
   * readonly
   */
  get computedReadonly () {
    // プロパティ優先
    if (this.readonly === true || this.readonly === 'true') {
      return true;
    }
    const readonly = (this.options && 'readonly' in this.options) ? this.options.readonly : false;
    return readonly;
  }

  /**
   * disabled
   */
  get computedDisabled () {
    // プロパティ優先
    if (this.disabled === true || this.disabled === 'true') {
      return true;
    }
    const disabled = (this.options && 'disabled' in this.options) ? this.options.disabled : false;
    return disabled || this.computedReadonly;
  }

  get autofocus () {
    return true;
  }

  // 親コンポーネントへの透過イベント
  onChange (...args) {
    this.$emit('app-event', 'change', this, ...args);
  }

  // 親コンポーネントへの透過イベント
  onClear (...args) {
    this.$refs.input.focus();
    this.$emit('app-event', 'clear', this, ...args);
  }

  // 親コンポーネントへの透過イベント
  onFocus (...args) {
    // スマホでは不便な動作となるので無効化
    // フォーカスを取得した時点でテキストを選択状態にする
    // if (this.$refs.input && this.$refs.input.select) {
    //   this.$refs.input.select();
    // }
    this.$emit('app-event', 'focus', this, ...args);
  }

  // 親コンポーネントへの透過イベント
  onBlur (...args) {
    this.$emit('app-event', 'blur', this, ...args);
  }

  // エンターキーイベント
  onEnterKey (event) {
    this.$emit('app-event', 'enterkey', event, this);
  }

  focus () {
    // ラベルとして用いられている場合には例外スロー
    if (this.computedReadonly || this.computedDisabled) {
      throw new Error('Can not set focus');
    }
    if (this.$refs.input && this.$refs.input.focus) {
      this.$refs.input.focus();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/input/AppInputComponent.vue